export default __webpack_public_path__ + "static/media/telecare-logo.8b16f130.svg";